// src/components/leads/TestCreate.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import { SingleImageDropzone } from "../DropzoneComponents";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function TestCreate() {
  /* i18n */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;

  /* form state */
  const [formData, setFormData] = useState({
    name: "",
    maxScore: "",
    description: "",
    price: "",
    categoryType: "0",
    hasSelection: false,
    isPopular: false,
    showOnHome: false,
    image: null,
    preview: null,
    testTypeIds: [],
    hasFeaturedCategory: false,  //  yeni alan
  questionCounter: 1,
  isFullyPaid: false,
  hasDualMainResult: false,
  hasDualCategoryResult: false,
  couponId: null  
  });
  const [loading, setLoading] = useState(false);
  const [types, setTypes] = useState([]);
  const [couponOptions, setCouponOptions] = useState([]);
  const nav = useNavigate();


// --- karşılıklı dışlama flags ---
const disableHasSelection          = formData.hasFeaturedCategory || formData.hasDualCategoryResult || formData.hasDualMainResult;
const disableHasFeaturedCategory   = formData.hasSelection        || formData.hasDualCategoryResult || formData.hasDualMainResult;
const disableHasDualCategoryResult = formData.hasSelection        || formData.hasFeaturedCategory   || formData.hasDualMainResult;
const disableHasDualMainResult     = formData.hasSelection        || formData.hasFeaturedCategory   || formData.hasDualCategoryResult;

// İkili Ana Sonuç varsa kategori tipi select’i ve “Seçim Olsun mu?” da kilitlensin
const categoryTypeDisabled = formData.hasDualMainResult;


  const update = (key, value) =>
    setFormData(prev => ({ ...prev, [key]: value }));

  /* test türlerini çek */
  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/test-types`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTypes((data || []).map(tt => ({
          value: tt.id,
          label: tt.name
        })));
      } catch (err) {
        console.error("❌ Türler alınamadı:", err);
        toast.error("Türler alınamadı");
      }
    };
    fetchTypes();
  }, []);

  /*  kuponları çek (aktif + tarihi uygun olanlar) */
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/coupons?active=1&valid=1`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // data: [{id, code, discount_type, discount_value, start_at, end_at, ...}]
        const options = (data || []).map((c) => ({
          value: c.id,
          label:
            c.discount_type === "percent"
              ? `${c.code} — %${c.discount_value}`
              : `${c.code} — ${Number(c.discount_value).toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} ₺`,
        }));
        setCouponOptions(options);
      } catch (err) {
        console.error("❌ Kupon listesi alınamadı:", err);
        // sessiz geçebiliriz; zorunlu değil
      }
    };
    fetchCoupons();
  }, []);

  // --- özel değiştiriciler ---
const onCategoryTypeChange = (e) => {
  if (categoryTypeDisabled) return;           // dual main açıkken değiştirme
  update("categoryType", e.target.value);
};

const onHasSelectionChange = (e) => {
  const checked = e.target.checked;
  setFormData(prev => ({
    ...prev,
    hasSelection: checked,
    ...(checked ? {
      hasFeaturedCategory: false,
      hasDualCategoryResult: false,
      hasDualMainResult: false, // biri seçildiğinde diğerleri kapanır
    } : {})
  }));
};

const onHasFeaturedChange = (e) => {
  const checked = e.target.checked;
  setFormData(prev => ({
    ...prev,
    hasFeaturedCategory: checked,
    ...(checked ? {
      hasSelection: false,
      hasDualCategoryResult: false,
      hasDualMainResult: false,
    } : {})
  }));
  if (!checked) update("questionCounter", 1);
};

const onHasDualCategoryChange = (e) => {
  const checked = e.target.checked;
  setFormData(prev => ({
    ...prev,
    hasDualCategoryResult: checked,
    ...(checked ? {
      hasSelection: false,
      hasFeaturedCategory: false,
      hasDualMainResult: false,
    } : {})
  }));
};

const onHasDualMainResultChange = (e) => {
  const checked = e.target.checked;
  setFormData(prev => ({
    ...prev,
    hasDualMainResult: checked,
    ...(checked ? {
      categoryType: "0",         // kategori yok
      hasSelection: false,
      hasFeaturedCategory: false,
      hasDualCategoryResult: false,
    } : {})
  }));
};



  /* submit */
  const handleSubmit = async e => {
    e.preventDefault();

    const name = formData.name.trim();
    const max = formData.maxScore;
    if (!name) return toast.error(t("NAME_REQ", "Test adı zorunlu"));
    if (max === "") return toast.error(t("SCORE_REQ", "Toplam puan zorunlu"));

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("name", name);
      fd.append("max_score", Number(max));
      fd.append("description", formData.description.trim());
      fd.append("show_on_home", formData.showOnHome ? 1 : 0);
      fd.append("is_fully_paid", formData.isFullyPaid ? 1 : 0);
fd.append("has_dual_category_result", formData.hasDualCategoryResult ? 1 : 0);
fd.append("has_dual_main_result", formData.hasDualMainResult ? 1 : 0);
      const catType = Number(formData.categoryType);
      const hasCategory = catType > 0 ? 1 : 0;
      const multipleCategory = catType === 2 ? 1 : 0;
      fd.append("has_category", hasCategory);
      fd.append("multiple_category", multipleCategory);
      fd.append("price", parseFloat(formData.price) || 0);

      fd.append("has_selection", formData.hasSelection ? 1 : 0);
      fd.append("is_popular", formData.isPopular ? 1 : 0);
      fd.append("has_featured_category", formData.hasFeaturedCategory ? 1 : 0);
fd.append("question_counter", formData.questionCounter || 1);
      if (formData.couponId) {
        fd.append("coupon_id", formData.couponId);
      }

      // Çoklu türler — backend bunları TestTypeTest tablosuna ekleyecek
      formData.testTypeIds.forEach(id => {
        fd.append("test_type_ids[]", id);
      });

      if (formData.image instanceof File) {
        fd.append("image", formData.image);
      }

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/tests`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`
          }
        }
      );

      toast.success("Test başarıyla oluşturuldu!");
      setTimeout(() => {
        nav(`/test/table`);
      }, 1000);
    } catch (err) {
      console.error("❌ Test oluşturma hatası:", err);
      toast.error(t("ERROR_CREATE", "Oluşturma sırasında hata oluştu"));
    } finally {
      setLoading(false);
    }
  };

  const maxWidth = 800;
  const maxHeight = 600;

  return (
    <div className="container mt-4">
      <ToastContainer />
      <form className="card p-4" onSubmit={handleSubmit}>
        <h5 className="mb-3 fw-bold">{t("CREATE_TEST", "Test Oluştur")}</h5>

        {/* Test Adı */}
        <div className="mb-3">
          <label className="form-label">{t("TEST_NAME", "Test Adı")}</label>
          <input
            type="text"
            className="form-control"
            value={formData.name}
            onChange={e => update("name", e.target.value)}
            placeholder={t("TITLE_PLACE", "Başlığı girin")}
            maxLength={255}
            disabled={loading}
            required
          />
        </div>

        {/* Test Türleri (çoklu) */}
        <div className="mb-3">
          <label className="form-label">Test Türleri</label>
          <Select
            isMulti
            options={types}
            value={types.filter(o => formData.testTypeIds.includes(o.value))}
            onChange={selected =>
              update("testTypeIds", selected.map(s => s.value))
            }
            isDisabled={loading}
            placeholder="Tür seçin (zorunlu değil)"
          />
        </div>

        {/* Toplam Puan */}
        <div className="mb-3">
          <label className="form-label">{t("MAX_SCORE", "Toplam Puan")}</label>
          <input
            type="number"
            className="form-control"
            value={formData.maxScore}
            onChange={e => update("maxScore", e.target.value)}
            min={0}
            step={1}
            placeholder={t("SCORE_PLACE", "Örn. 100")}
            disabled={loading}
            required
          />
        </div>

        {/* Açıklama */}
        <div className="mb-3">
          <label className="form-label">{t("DESCRIPTION", "Açıklama")}</label>
          <textarea
            className="form-control"
            rows={4}
            value={formData.description}
            onChange={e => update("description", e.target.value)}
            placeholder={t("DESCRIPTION_PLACE", "Test açıklamasını girin.")}
            disabled={loading}
          />
        </div>
                  <div className="mb-3">
            <label className="form-label">
              Sayfada gösterilecek soru sayısı
            </label>
            <input
              type="number"
              className="form-control"
              value={formData.questionCounter || 1}
              onChange={e => update("questionCounter", e.target.value)}
              min={1}
              step={1}
              placeholder="Örn. 10"
              disabled={loading}
            />
          </div>



        {/* Fiyat */}
        <div className="mb-3">
          <label className="form-label">{t("PRICE", "Fiyat")}</label>
          <input
            type="number"
            step="0.01"
            min="0"
            className="form-control"
            value={formData.price}
            onChange={e => update("price", e.target.value)}
            placeholder={t("PRICE_PLACE", "Örn. 19.99")}
            disabled={loading}
            required
          />
        </div>

        
        {/* Kategori Tipi */}
        <div className="mb-3">
          <label className="form-label">{t("CATEGORY_TYPE", "Kategori Tipi")}</label>
          <select
            className="form-select"
            value={formData.categoryType}
            onChange={e => update("categoryType", e.target.value)}
            disabled={loading || categoryTypeDisabled}
          >
            <option value="0">{t("NO_CATEGORY", "Kategori yok")}</option>
            <option value="1">{t("SINGLE_CATEGORY", "Tekli seçim")}</option>
            <option value="2">{t("MULTIPLE_CATEGORY", "Çoklu seçim")}</option>
          </select>
        </div>

                {/* Popüler Test */}
        <div className="form-check mb-3">
          <input
            type="checkbox"
            id="isPopular"
            className="form-check-input"
            checked={formData.isPopular}
            onChange={e => update("isPopular", e.target.checked)}
            disabled={loading}
          />
          <label className="form-check-label" htmlFor="isPopular">
            {t("IS_POPULAR", "Popüler Test Olsun Mu?")}
          </label>
        </div>
               {/*Anasayfada Görünsün mü? */} 
        <div className="form-check mb-3">  
          <input
            type="checkbox"
            id="showOnHome"
            className="form-check-input"
            checked={formData.showOnHome}
            onChange={e => update("showOnHome", e.target.checked)}
            disabled={loading}
          />
          <label className="form-check-label" htmlFor="showOnHome">
            {t("SHOW_ON_HOME", "Anasayfada Görünsün mü?")}
          </label>
        </div>
        
        {/* Tamamen Ücretli mi? */}
<div className="form-check mb-3">
  <input
    type="checkbox"
    id="isFullyPaid"
    className="form-check-input"
    checked={formData.isFullyPaid}
    onChange={e => update("isFullyPaid", e.target.checked)}
    disabled={loading}
  />
  <label className="form-check-label" htmlFor="isFullyPaid">
    Tamamen Ücretli mi? (Ödeme yapıldıktan sonra test çözülebilir)
  </label>
</div>

        {/* Seçim olsun mu? */}
        <div className="form-check mb-3">
          <input
            type="checkbox"
            id="hasSelection"
            className="form-check-input"
            checked={formData.hasSelection}
            onChange={e => update("hasSelection", e.target.checked)}
            disabled={loading || disableHasSelection}
          />
          <label className="form-check-label" htmlFor="hasSelection">
            {t("HAS_SELECTION", "Seçim Olsun Mu? (İlk başta kategori seçtirecek miyiz?)")}
          </label>
        </div>


                {/* Öne Çıkan Kategori (tek kategoriye göre sonuç) */}
        <div className="form-check mb-3">
          <input
            type="checkbox"
            id="hasFeaturedCategory"
            className="form-check-input"
            checked={formData.hasFeaturedCategory || false}
            onChange={e => {
              const checked = e.target.checked;
              update("hasFeaturedCategory", checked);
              if (!checked) {
                // kapatıldığında counter'ı 1'e resetle
                update("questionCounter", 1);
              }
            }}
            disabled={loading || disableHasFeaturedCategory}
          />
          <label className="form-check-label" htmlFor="hasFeaturedCategory">
            Tek bir kategoriye göre sonuç çıksın mı? (En çok puan alan kategorinin sonucuna göre)
          </label>
        </div>

<div className="form-check mb-3">
  <input
    type="checkbox"
    id="hasDualCategoryResult"
    className="form-check-input"
    checked={formData.hasDualCategoryResult}
    onChange={e => update("hasDualCategoryResult", e.target.checked)}
    disabled={loading || disableHasDualCategoryResult}
  />
  <label className="form-check-label" htmlFor="hasDualCategoryResult">
    İki kategoriye göre sonuç çıksın mı? (En çok puan alan iki kategorinin sonucuna göre)
  </label>
</div>

{/* İkili Ana Sonuç (JSON sonuç sayfası mantığı) */}
<div className="form-check mb-3">
  <input
    type="checkbox"
    id="hasDualMainResult"
    className="form-check-input"
    checked={formData.hasDualMainResult}
    onChange={e => update("hasDualMainResult", e.target.checked)}
    disabled={loading || disableHasDualMainResult}
  />
  <label className="form-check-label" htmlFor="hasDualMainResult">
    İkili Ana Sonuç Sayfası Kullanılsın mı? (Ana editör, Yan editör) Bu şık tercih edildiği zaman kategori tercihi yapmayınız.
  </label>
</div>

        {/* Resim */}
        <div className="mb-3">
          <label className="form-label">
            Resim ({maxWidth}x{maxHeight} px)
          </label>
          <SingleImageDropzone
            fieldName="image"
            fieldValue={formData.preview || formData.image}
            setFieldValues={() => {}}
            onChange={file => {
              update("image", file);
              update("preview", URL.createObjectURL(file));
            }}
            onRemove={() => {
              update("image", null);
              update("preview", null);
            }}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
            disabled={loading}
            required={false}
          />
        </div>

        {/* Kaydet */}
        <div className="d-flex justify-content-center mt-4">
          <button
            type="submit"
            className="btn btn-primary px-4"
            disabled={loading}
          >
            {loading ? t("LOADING", "Yükleniyor…") : t("SAVE", "Kaydet")}
          </button>
        </div>
      </form>
    </div>
  );
}
